import { formatLocalizedDate, localeTag, translate } from '@/i18n'

export function formatMoney(value, currency = 'TZS') {
  return `${new Intl.NumberFormat(localeTag(), { maximumFractionDigits: 0 }).format(value || 0)} ${currency}`
}

export function formatMonth(value) {
  return value ? formatLocalizedDate(value, { month: 'short', year: 'numeric' }) : translate('common.notSpecified')
}

export function formatDate(value) {
  return value ? formatLocalizedDate(value, { day: '2-digit', month: 'short', year: 'numeric' }) : translate('common.notSpecified')
}

export function formatPercent(value) {
  return value === null || value === undefined || value === '' ? translate('common.notSpecified') : `${value}%`
}

export function progressPercent(part, total) {
  if (!total) return 0
  return Math.min(100, Math.max(0, (Number(part) / Number(total)) * 100))
}
